const initialState = {
  storeName: null,
  label: null,
  storeId: null,
  storeCountry: null,
  storeLocation: null,
  storeBU: null,
  moduleIds: null,
};

const storeReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_STORE_DETAILS":
      const {uuid, name, businessUnit, country, location} = action?.payload?.data;
      return {
        ...state,
        storeName: name,
        label: name,
        storeId: uuid,
        storeCountry: country,
        storeLocation: location,
        storeBU: businessUnit,
      };
    case "SET_MODULE_IDS":
      return {
        ...state,
        moduleIds: action.payload.moduleIds,
      };
    default:
      return state;
  }
};

export default storeReducer;
